const KEY = 'zsp.lastAccountId';

/** Which line to open when the URL does not say — and NOTHING else.
 *
 *  The whole point of putting the account in the URL is that no shared mutable
 *  "current account" exists, so two tabs can sit in two different lines at once. This
 *  value is the one exception, and it stays harmless only because of a rule:
 *
 *    ONLY the `/` resolver may read it.
 *
 *  A page that reads it to decide what to show has re-created the global current
 *  account, with an extra screen on top — two tabs would start fighting again. If you
 *  find yourself wanting it inside a page, what you actually want is
 *  `useCurrentAccount()`, which reads the URL.
 *
 *  Writing is different and safe: `AccountScope` records wherever you land, so the
 *  next cold start reopens it. */
export function readLastAccountId(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    // Private-mode Safari throws on localStorage. A forgotten preference is not
    // worth a blank app — the resolver falls back to picking for itself.
    return null;
  }
}

export function rememberAccountId(accountId: string): void {
  try {
    localStorage.setItem(KEY, accountId);
  } catch {
    /* see above */
  }
}
